module.exports = __webpack_public_path__ + "img/product_61.a9b5dd9.webp";